import dayjs from "dayjs";

/**
 * Render a date object to a human-readable form.
 * @param date a date + time to render
 */
export const renderDateAndTime: (date: Date) => string = (date: Date) => {
    return `${dayjs(date).format("DD MMM YYYY [-] HH:mm")}`;
};

